import Page from '../../components/PageWrapper';
import { Outlet } from 'react-router-dom';

function BranchDetails() {

  return (
    <Page title='Branches'>
      <Outlet />
    </Page>
  );
}

export default BranchDetails;
